import { Component, OnInit } from '@angular/core';
import * as XLSX from 'xlsx';
import { AwsService } from "../../../providers/appsyncservice/aws.service";

@Component({
  selector: 'app-car-upload',
  templateUrl: './car-upload.component.html',
  styleUrls: ['./car-upload.component.css']
})
export class CarUploadComponent implements OnInit {
  file: File
  displayValue: number = 0;
  progresspercent: number = 0;
  uploadStatus: Number;
  uploadList: any[] = [];
  statusList: any[] = [];
  arrayBuffer: any;
  sheetlength: number = 0;
  cnt: number = 1;
  vendorList: any = [];
  userList: any = [];

  constructor(public awserviceProvider: AwsService) { }

  ngOnInit() {
    this.progresspercent = 0;
    this.getVendorData();
  }

  incomingfile(event) {
    this.uploadStatus = -1;
    this.file = event.target.files[0];
    // alert( this.file.name)
  }

  uploadtrip() {
    if (this.file == undefined) {
      this.uploadStatus = 0;
      return;
    }

    this.statusList = [];
    this.uploadList = [];
    this.progresspercent = 0;
    this.uploadStatus = 1;
    this.displayValue = 0;
    this.userList = [];

    let fileReader = new FileReader();
    fileReader.onload = (e) => {
      //alert("inside");
      // this.uploadStatus = 1;
      this.arrayBuffer = fileReader.result;
      var data = new Uint8Array(this.arrayBuffer);
      var arr = new Array();
      for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
      var bstr = arr.join("");
      var workbook = XLSX.read(bstr, { type: "binary" });
      var first_sheet_name = workbook.SheetNames[0];
      console.log("first_sheet_name", first_sheet_name);
      var worksheet = workbook.Sheets["data"];
      var sheet = XLSX.utils.sheet_to_json(worksheet, { raw: true })
      // console.log("first_sheet_json", sheet.toString);
      console.log("first_sheet_length", sheet.length);
      this.sheetlength = sheet.length;
      this.startProcess(sheet);
    }
    fileReader.readAsArrayBuffer(this.file);
    this.uploadStatus = 1;
  }

  //After reading insert the record 
  async startProcess(sheet) {
    // bar.update(0.5);
    // console.log("FULL", sheet)
    var rnNumberSet = new Set();
    for (const dict of sheet) {

      var s_no = String(dict["S.No"]).trim();
      var car_model = String(dict["Car Model"]).trim();
      var vehicle_reg_no = String(dict["Vehicle Registration No"]).trim();
      var policy_no = String(dict["Policy No"]).trim();
      var policy_start_date = String(dict["Policy Start Date"]).trim();
      var policy_end_date = String(dict["Policy End Date"]).trim();
      var lease_start_date = String(dict["Lease Start Date"]).trim();
      var lease_end_date = String(dict["Lease End Date"]).trim();
      var vendor_name = String(dict["Vendor Name"]).trim();
      var rn_number = String(dict["RN Number"]).trim();
      var assigned_date = String(dict["Assigned Date"]).trim();
      var car_type = String(dict["Car Type"]).trim();

      console.log('s_no: ' + s_no
        + ' car_model: ' + car_model + ' vehicle_reg_no: ' + vehicle_reg_no
        + ' policy_no: ' + policy_no + ' policy_start_date: ' + policy_start_date + ' policy_end_date: ' + policy_end_date
        + ' lease_start_date: ' + lease_start_date + ' lease_end_date: ' + lease_end_date
        + ' vendor_name: ' + vendor_name + ' rn_number: ' + rn_number + ' assigned_date: ' + assigned_date + ' Car Type: ' + car_type);

      var carData = {
        'car_model': car_model,
        'veh_reg_id': vehicle_reg_no,
        'policy_no': policy_no,
        'policy_from': policy_start_date,
        'policy_to': policy_end_date,
        'lease_from': lease_start_date,
        'lease_to': lease_end_date,
        'ex_data': "ASSIGN",
        'agency_name': vendor_name,
        'rn_number': rn_number,
        'assigned_date': assigned_date,
        'car_type': car_type
      }

      console.log('--------carData------------');
      console.log(carData);

      // this.validateData(s_no, carData);

      var errorText = ""

      if (this.isInvalid(carData.car_model)) {
        errorText = errorText + 'Invalid Car Model :: '
      }
      if (this.isInvalid(carData.veh_reg_id)) {
        errorText = errorText + 'Invalid Vehicle Registration Number :: '
      }
      if (this.isInvalid(carData.policy_no)) {
        errorText = errorText + 'Invalid Policy Number :: '
      }
      if (this.isInvalid(carData.policy_from)) {
        errorText = errorText + 'Invalid Policy Start Date :: '
      } else {
        var dateSplitArr = carData.policy_from.split('-');
        if (dateSplitArr.length != 3 || dateSplitArr[0].length != 4 || dateSplitArr[1].length != 2 || dateSplitArr[2].length != 2) {
          errorText = errorText + 'Invalid Policy Start Date :: ' + carData.policy_from + ' :: '
        }
      }
      if (this.isInvalid(carData.policy_to)) {
        errorText = errorText + 'Invalid Policy End Date :: '
      } else {
        var dateSplitArr = carData.policy_to.split('-');
        if (dateSplitArr.length != 3 || dateSplitArr[0].length != 4 || dateSplitArr[1].length != 2 || dateSplitArr[2].length != 2) {
          errorText = errorText + 'Invalid Policy End Date :: '
        }
      }
      if (this.isInvalid(carData.lease_from)) {
        errorText = errorText + 'Invalid Lease Start Date :: '
      } else {
        var dateSplitArr = carData.lease_from.split('-');
        if (dateSplitArr.length != 3 || dateSplitArr[0].length != 4 || dateSplitArr[1].length != 2 || dateSplitArr[2].length != 2) {
          errorText = errorText + 'Invalid Lease Start Date :: '
        }
      }
      if (this.isInvalid(carData.lease_to)) {
        errorText = errorText + 'Invalid Lease End Date :: '
      } else {
        var dateSplitArr = carData.lease_to.split('-');
        if (dateSplitArr.length != 3 || dateSplitArr[0].length != 4 || dateSplitArr[1].length != 2 || dateSplitArr[2].length != 2) {
          errorText = errorText + 'Invalid Lease End Date :: '
        }
      }

      if (this.isInvalid(carData.agency_name)) {
        errorText = errorText + 'Invalid Vendor Name :: '
      } else {
        var isVendorAvailable = false;
        for (var i = 0; i < this.vendorList.length; i++) {
          if (carData.agency_name === this.vendorList[i].name) {
            // console.log('-----' + carData.owner_exdata);
            // console.log(this.vendorList[i]);
            carData.agency_name = this.vendorList[i].id
            isVendorAvailable = true;
          }
        }
        if (!isVendorAvailable) {
          errorText = errorText + 'Invalid Vendor Name - Not Found :: '
        }
      }

      if (this.isInvalid(carData.assigned_date)) {
        errorText = errorText + 'Invalid Assigned Date :: '
      } else {
        var dateSplitArr = carData.assigned_date.split('-');
        if (dateSplitArr.length != 3 || dateSplitArr[0].length != 4 || dateSplitArr[1].length != 2 || dateSplitArr[2].length != 2) {
          errorText = errorText + 'Invalid Assigned Date :: '
        }
      }

      // console.log('rn_number: ' + carData.rn_number)
      if (this.isInvalid(carData.rn_number)) {
        errorText = errorText + 'Invalid RN Number :: '
      } else {
        if (!carData.rn_number.startsWith('RN') || (carData.rn_number.length < 7)) {
          errorText = errorText + 'Invalid RN Number :: --> '
          // console.log('carData.rn_number.length: ' + carData.rn_number.length)
        } else {
          /* if (rnNumberSet.has(carData.rn_number)) {
            errorText = errorText + 'Duplicate RN Number :: '
          } else {
            const isAssigned = await this.isCarAssignedtoUser(carData.rn_number)
            // console.log('-----> isAssigned value: ' + isAssigned);
            if (isAssigned) {
              errorText = errorText + 'Car already assigned to ' + carData.rn_number + ' :: '
            } else { */
              const isRNNumberAvailable = await this.isRNNumberAvailable(carData.rn_number)
              // console.log('-----> isRNNumberAvailable value: ' + isRNNumberAvailable);
              if (isRNNumberAvailable) {
                rnNumberSet.add(carData.rn_number);
              } else {
                errorText = errorText + 'RN Number ' + carData.rn_number + ' does not exist :: '
              }
            //}
          //}
        }
      }

      if (this.isInvalid(carData.car_type)) {
        errorText = errorText + 'Invalid Car Type :: '
      } else {
        if (carData.car_type.toLowerCase().includes("office")) {
          carData.car_type = 'Office Car'
        } else if (carData.car_type.toLowerCase().includes("family")) {
          carData.car_type = 'Family Car'
        } else if (carData.car_type.toLowerCase().includes("others")) {
          carData.car_type = 'Others'
        } else {
          errorText = errorText + 'Invalid Car Type - ' + carData.car_type + ' :: '
        }
      }

      if (errorText.length > 0) {
        // console.log("----------" + errorText)
        this.statusList.push({ line_no: s_no, status: 'Error', error: errorText });
        this.displayValue = 1;
        this.uploadStatus = 3;
      } else {
        this.uploadList.push(carData)
        this.progressIncrement();
      }

    }

    // console.log('this.statusList: ' + this.statusList)
    // console.log('this.uploadList: ' + this.uploadList)

    // console.log('-----', rnNumberSet)
    // console.log('-----', this.userList)

    if (this.statusList.length == 0 && this.uploadList.length > 0) {
      // console.log('inside if');
      for (var i = 0; i < this.uploadList.length; i++) {
        var item = this.uploadList[i];
        // console.log('----- ' + 'item.carData ' + item.carData);

        this.createCarData(item);
      }
    }
  }

  progressIncrement() {
    if (this.cnt == this.sheetlength) {
      this.uploadStatus = 2;
    }
    //  // console.log("progresspercent",   Math.round(this.cnt * 100 / this.sheetlength)    );
    this.progresspercent = this.cnt * 50 / this.sheetlength;
    this.cnt++;
  }

  isInvalid(str) {
    if (str == 'undefined' || str == null || str.length < 1)
      return true;
    else
      return false;
  }

  // GET DATA
  getVendorData() {
    this.vendorList = [];
    // console.log("GET VENDOR LIST");
    this.awserviceProvider.getActiveVendorlist().then(data => {
      this.vendorList = data.filter(res => res.vendor_type === "Car");
      console.log("vendorList", this.vendorList);
    });
  }

  validateEmail(emailStr) {
    var emailFormat = /\S+@\S+\.\S+/;
    if (emailFormat.test(emailStr)) {
      // console.log('------ test Email Valid: ', emailStr)
      return true;
    } else {
      // console.log('------ test Email Invalid: ', emailStr)
      return false;
    }
  }

  async isRNNumberAvailable(rn_number) {
    // console.log("Searching RN Number in RNC Users.....", rn_number);
    var isRNNumberAvailable = await this.awserviceProvider
      .rnUserFilter(rn_number)
      .then(result => {
        if (result.length === 0) {
          // console.log('--- RN number not available: ' + rn_number);
          return false;
        } else {
          // console.log("--- RN number details" + rn_number);
          // console.log(result);
          if (result.length > 0) {
            this.userList.push(result[0]);
          }
          return true;
        }
      })
      .catch(err => {
        console.log("err", err);
      });
    // console.log('----- isRNNumberAvailable: ' + isRNNumberAvailable);
    return isRNNumberAvailable;
  }

  async isCarAssignedtoUser(rn_number) {
    // console.log("Checking Car assigned to RN Number.....", rn_number);
    var isAssigned = await this.awserviceProvider
      .filterRnExistCar(rn_number)
      .then(result => {
        // console.log(result);
        if (result.length === 0) {
          // console.log('--- Car not assigned to RN number: ' + rn_number);
          return false;
        } else {
          // console.log('--- Car already assigned to RN number: ' + rn_number);
          //TODO: check active Car
          return true;
        }
      })
      .catch(err => {
        console.log("err", err);
      });
    // console.log('----- isAssigned: ' + isAssigned);
    return isAssigned;
  }

  createCarData(carData) {
    console.log("Create Car data called .....", carData);
    // # CREATE RECORD #
    console.log("car master create");
    this.awserviceProvider
      .CreateCarData(carData)
      .then(result => {
        console.log('------ Car master record created ------')
        console.log("createdata-car result", result);
        carData.car_id = result.id;
        this.createAssignCar(carData);
      })
      .catch(err => {
        console.log("err", err);
      });
  }

  createAssignCar(carData) {
    console.log("Create AssignCar called .....", carData);
    var empData;
    for (var i = 0; i < this.userList.length; i++) {
      var user = this.userList[i];
      if (user.user_name === carData.rn_number) {
        empData = user;
        break;
      }
    }

    var assignCarData = {
      user_pid: empData.id, // user ID
      rn_id: carData.rn_number,
      car_id: carData.car_id,
      assigned_date: carData.assigned_date,
      status: 'ASSIGN',
      ex_data: carData.car_type
    };

    // # CREATE RECORD #
    this.awserviceProvider
      .CreateAssignCar(assignCarData)
      .then(resultData => {
        console.log("createAssignCar resultData: ", resultData);
        this.updateMasterCar(resultData);
      })
      .catch(err => {
        console.log("err", err);
      });
  }

  updateMasterCar(carUpdateData) {
    console.log("updateMasterCar", carUpdateData);
    this.awserviceProvider
      .updateMasterCar(carUpdateData)
      .then(result => {
        console.log("updateMasterCar", result);
        this.progressIncrement()
      })
      .catch(err => {
        console.log("err", err);
      });
  }

}
